// DynamicRecursiveComp.jsx
import React, { useMemo, useCallback } from "react";
import "./DynamicRecursiveComp.css";
import * as FeatherIcon from "react-feather";
import VerticalDivider from "../components/HtmlElements/VerticalDivider";
import HorizontalDivider from "../components/Frontend/AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/NurtureCampaignContact/HorizontalDivider";
/** Default item view if you don't pass a custom one */
function DefaultItemView({ item }) {
  return (
    <div className="drc-item-content">
      <div className="drc-item-title">{item?.sub ?? "—"}</div>
      <div className="drc-item-body">{item?.body ?? "—"}</div>
      <div className="drc-item-date">{item?.date ?? ""}</div>
    </div>
  );
}

/**
 * DynamicRecursiveComp
 * Props:
 * - data: Array of nodes. Children under `repliesKey` (default "replies")
 * - ItemComp: Component to render a node (receives { item, depth, index, path })
 * - repliesKey: string key for children array (default "replies")
 * - getKey: function to generate a stable key per node
 * - collapsible: enable expand/collapse for nodes with children (default true)
 * - initiallyCollapsed: start collapsed for nodes with children (default false)
 */
export default function DynamicRecursiveComp({
  data = [],
  ItemComp = DefaultItemView,
  repliesKey = "replies",
  getKey,
  collapsible = true,
  initiallyCollapsed = false,
}) {
  console.log("data", data);
  // Fallback key generator
  const fallbackKey = useCallback(
    (item, index, path) =>
      item?._id ||
      item?.id ||
      `${item?.sub ?? "node"}_${item?.date ?? ""}_${path.join("-")}_${index}`,
    []
  );
  const makeKey = getKey || fallbackKey;

  const safeData = useMemo(() => (Array.isArray(data) ? data : []), [data]);

  return (
    <div >
      {/* <ul className="drc-list" data-depth={0}> */}
     
        {safeData.map((item, idx) => (
  <React.Fragment key={makeKey(item, idx, [])}>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center", // ensures the connector is centered
      }}
    >
      <Node
        item={item}
        depth={0}
        index={idx}
        path={[]}
        ItemComp={ItemComp}
        repliesKey={repliesKey}
        makeKey={makeKey}
        collapsible={collapsible}
        initiallyCollapsed={initiallyCollapsed}
      />

      {/* connector */}
      {idx < safeData.length - 1 && (
        <div
          style={{
            width: "2px",
            height: "2rem",
            borderLeft: "2px dotted #999",
          }}
        />
      )}
    </div>
  </React.Fragment>
))}


         
      {/* </ul> */}
    </div>
  );
}

/** One node in the tree; safe place to use hooks */
function Node({
  item,
  depth,
  index,
  path,
  ItemComp,
  repliesKey,
  makeKey,
  collapsible,
  initiallyCollapsed,
}) {
  const React_ = React; // keep eslint calm if needed in some setups
  const { useState, useMemo } = React_;
  const key = useMemo(
    () => makeKey(item, index, path),
    [item, index, path, makeKey]
  );

  const children = item?.[repliesKey];
  const hasChildren = Array.isArray(children) && children.length > 0;

  const [collapsed, setCollapsed] = useState(
    hasChildren ? initiallyCollapsed : false
  );

  return (
    <div>
      <div className="drc-row">
        {hasChildren && collapsible && (
          <button
            className={`drc-toggle ${
              collapsed ? "is-collapsed" : "is-expanded"
            }`}
            onClick={() => setCollapsed((c) => !c)}
            aria-label={collapsed ? "Expand" : "Collapse"}
            title={collapsed ? "Expand" : "Collapse"}
          >
            {collapsed ? (
              <FeatherIcon.ChevronDown />
            ) : (
              <FeatherIcon.ChevronUp />
            )}
          </button>
        )}

        <ItemComp item={item} depth={depth} index={index} path={path} />
      </div>

      {hasChildren && !collapsed && (
        // <div className="drc-children">
          // <ul className="drc-list" data-depth={depth + 1}>
          <>
            {children.map((child, cIdx) => (
              <Node
                key={makeKey(child, cIdx, [...path, index])}
                item={child}
                depth={depth + 1}
                index={cIdx}
                path={[...path, index]}
                ItemComp={ItemComp}
                repliesKey={repliesKey}
                makeKey={makeKey}
                collapsible={collapsible}
                initiallyCollapsed={initiallyCollapsed}
              />
            ))}
            </>
          // </ul>
        // </div>
      )}
    </div>
  );
}
